(() => {
  if (window.atharCarouselReady) return;
  window.atharCarouselReady = true;

  function findCarousel(button) {
    const direct = button.closest('[data-athar-carousel]');
    if (direct) return direct;

    const section = button.closest('.athar-page, .athar-icons, .shopify-section');
    return section ? section.querySelector('[data-athar-carousel]') : null;
  }

  function scrollCarousel(button, direction) {
    const carousel = findCarousel(button);
    const track = carousel ? carousel.querySelector('[data-athar-carousel-track]') : null;
    if (!track) return;

    const firstItem = track.firstElementChild;
    const itemWidth = firstItem ? firstItem.getBoundingClientRect().width : track.clientWidth * 0.8;
    const styles = window.getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

    track.scrollBy({
      left: direction * (itemWidth + gap),
      behavior: 'smooth',
    });
  }

  document.addEventListener('click', (event) => {
    const previous = event.target.closest('[data-athar-carousel-prev]');
    const next = event.target.closest('[data-athar-carousel-next]');

    if (previous) scrollCarousel(previous, -1);
    if (next) scrollCarousel(next, 1);
  });
})();
